// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddressPopup_address_modal__cVWKU {
  max-width: 816px;
  padding: 0px 25px;
}
.AddressPopup_address_container__eQS7G {
  display: flex;
  justify-content: space-between;
}

.AddressPopup_text_label__JxGxj {
  margin-bottom: 5px;
}

.AddressPopup_address_row__5Ty2W {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 10px;
}

.AddressPopup_address_header__nY2Iy {
  padding-top: 10px;
  color: #283371;
}

.AddressPopup_half_form__6V6X3 {
  width: 48%;
}

.AddressPopup_country_text__Z0p3Q {
  margin: 14px 0px 0px 0px !important;
  font-weight: bold;
}

.AddressPopup_billing_header__mMY-c {
  font-size: 16px;
}

.AddressPopup_billing_container__jz2b- {
  margin-bottom: 20px;
  min-width: 530px;
}

.AddressPopup_billing_input__qSF96 {
  width: 100%;
  height: 30px;
  border: none;
  border-bottom: 1px solid #e4e7e8;
}

.AddressPopup_button__\\+ZwnD {
  float: right;
}

.AddressPopup_required_info__g5ozE {
  font-size: 12px;
  display: flex;
  justify-content: flex-end;
  padding: 10px 0px;
}

.AddressPopup_mobile_view__Q39er {
  display: none;
}

.AddressPopup_actionsContainer__wWvGf {
  padding-left: 15px;

  display: flex;
  flex-direction: column;
  align-content: flex-end;
  align-items: flex-end;
}
@media only screen and (max-width: 600px) {
  .AddressPopup_address_modal__cVWKU {
    min-width: 0px;
    max-width: 816px;
    background-color: #ffffff;
    padding: 0px 25px;
  }
  .AddressPopup_billing_container__jz2b- {
    margin-bottom: 20px;
    min-width: 100%;
  }
  .AddressPopup_mobile_view__Q39er {
    display: initial;
  }
  .AddressPopup_normal_view__4dCUJ {
    display: none;
  }
  .AddressPopup_actionsContainer__wWvGf {
    align-items: center;
  }
  .AddressPopup_country_text__Z0p3Q {
    padding-left: 10px;
  }
}

@media screen and (max-width: 500px) {
  .AddressPopup_mobile_view__Q39er {
    display: initial;
  }
  .AddressPopup_normal_view__4dCUJ {
    display: none;
  }
  .AddressPopup_address_modal__cVWKU {
    width: -webkit-fill-available;
    height: auto;
    padding: 15px;
  }
  .AddressPopup_billing_container__jz2b- {
    margin-bottom: 20px;
    min-width: 100%;
  }

  .AddressPopup_address_container__eQS7G {
    display: block;
  }
  .AddressPopup_address_header_mobile__hvRQ5 {
    display: flex;
    margin: 0px;
  }
}

.AddressPopup_header_container__PYOcz {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.AddressPopup_nameWarningContainer__PwrjY {
  font-size: 13px;
  margin-bottom: 19px;
  margin-top: -25px;
  color: red;
}
`, "",{"version":3,"sources":["webpack://./src/@_components/popups/AddressPopup/AddressPopup.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;;EAElB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;AACvB;AACA;EACE;IACE,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,iBAAiB;EACnB;EACA;IACE,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,6BAA6B;IAC7B,YAAY;IACZ,aAAa;EACf;EACA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;EACA;IACE,aAAa;IACb,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,UAAU;AACZ","sourcesContent":[".address_modal {\n  max-width: 816px;\n  padding: 0px 25px;\n}\n.address_container {\n  display: flex;\n  justify-content: space-between;\n}\n\n.text_label {\n  margin-bottom: 5px;\n}\n\n.address_row {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n\n.address_header {\n  padding-top: 10px;\n  color: #283371;\n}\n\n.half_form {\n  width: 48%;\n}\n\n.country_text {\n  margin: 14px 0px 0px 0px !important;\n  font-weight: bold;\n}\n\n.billing_header {\n  font-size: 16px;\n}\n\n.billing_container {\n  margin-bottom: 20px;\n  min-width: 530px;\n}\n\n.billing_input {\n  width: 100%;\n  height: 30px;\n  border: none;\n  border-bottom: 1px solid #e4e7e8;\n}\n\n.button {\n  float: right;\n}\n\n.required_info {\n  font-size: 12px;\n  display: flex;\n  justify-content: flex-end;\n  padding: 10px 0px;\n}\n\n.mobile_view {\n  display: none;\n}\n\n.actionsContainer {\n  padding-left: 15px;\n\n  display: flex;\n  flex-direction: column;\n  align-content: flex-end;\n  align-items: flex-end;\n}\n@media only screen and (max-width: 600px) {\n  .address_modal {\n    min-width: 0px;\n    max-width: 816px;\n    background-color: #ffffff;\n    padding: 0px 25px;\n  }\n  .billing_container {\n    margin-bottom: 20px;\n    min-width: 100%;\n  }\n  .mobile_view {\n    display: initial;\n  }\n  .normal_view {\n    display: none;\n  }\n  .actionsContainer {\n    align-items: center;\n  }\n  .country_text {\n    padding-left: 10px;\n  }\n}\n\n@media screen and (max-width: 500px) {\n  .mobile_view {\n    display: initial;\n  }\n  .normal_view {\n    display: none;\n  }\n  .address_modal {\n    width: -webkit-fill-available;\n    height: auto;\n    padding: 15px;\n  }\n  .billing_container {\n    margin-bottom: 20px;\n    min-width: 100%;\n  }\n\n  .address_container {\n    display: block;\n  }\n  .address_header_mobile {\n    display: flex;\n    margin: 0px;\n  }\n}\n\n.header_container {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.nameWarningContainer {\n  font-size: 13px;\n  margin-bottom: 19px;\n  margin-top: -25px;\n  color: red;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"address_modal": `AddressPopup_address_modal__cVWKU`,
	"address_container": `AddressPopup_address_container__eQS7G`,
	"text_label": `AddressPopup_text_label__JxGxj`,
	"address_row": `AddressPopup_address_row__5Ty2W`,
	"address_header": `AddressPopup_address_header__nY2Iy`,
	"half_form": `AddressPopup_half_form__6V6X3`,
	"country_text": `AddressPopup_country_text__Z0p3Q`,
	"billing_header": `AddressPopup_billing_header__mMY-c`,
	"billing_container": `AddressPopup_billing_container__jz2b-`,
	"billing_input": `AddressPopup_billing_input__qSF96`,
	"button": `AddressPopup_button__+ZwnD`,
	"required_info": `AddressPopup_required_info__g5ozE`,
	"mobile_view": `AddressPopup_mobile_view__Q39er`,
	"actionsContainer": `AddressPopup_actionsContainer__wWvGf`,
	"normal_view": `AddressPopup_normal_view__4dCUJ`,
	"address_header_mobile": `AddressPopup_address_header_mobile__hvRQ5`,
	"header_container": `AddressPopup_header_container__PYOcz`,
	"nameWarningContainer": `AddressPopup_nameWarningContainer__PwrjY`
};
export default ___CSS_LOADER_EXPORT___;
